import React, { useEffect, useState } from "react";
import api from "../../axiosConfig";
import { Table, Container, Row, Col, Tabs, Tab, Spinner } from "react-bootstrap";
import { format2 } from "../utils/rounding";

const ObInvIstoricMiscari = () => {
  const [activeTab, setActiveTab] = useState("dari");

  const [dari, setDari] = useState([]);
  const [transferuri, setTransferuri] = useState([]);
  const [casari, setCasari] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchData(activeTab);
  }, [activeTab]);

  const fetchData = async (tab) => {
    setLoading(true);
    try {
      if (tab === "dari" && dari.length === 0) {
        const res = await api.get("/obinv/rapoarte/dare_folosinta_linii/");
        setDari(res.data);
      } else if (tab === "transferuri" && transferuri.length === 0) {
        const res = await api.get("/obinv/rapoarte/transfer_linii/");
        setTransferuri(res.data);
      } else if (tab === "casari" && casari.length === 0) {
        const res = await api.get("/obinv/rapoarte/casari_linii/");
        setCasari(res.data);
      }
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  return (
    <Container className="mt-4">
      <Row className="mb-3">
        <Col>
          <h2>Istoric Mișcări Obiecte Inventar</h2>
        </Col>
      </Row>

      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="mb-3"
      >
        <Tab eventKey="dari" title="Dări în Folosință">
          {loading && dari.length === 0 ? <Spinner animation="border" /> : (
            <Table striped bordered hover size="sm">
              <thead className="table-primary">
                <tr>
                  <th>Data</th>
                  <th>Nr. Doc</th>
                  <th>Angajat</th>
                  <th>Cod Produs</th>
                  <th>Denumire</th>
                  <th className="text-end">Cantitate</th>
                  <th className="text-end">Preț</th>
                  <th className="text-end">Valoare</th>
                </tr>
              </thead>
              <tbody>
                {dari.map((it, idx) => (
                  <tr key={idx}>
                    <td>{it.doc_date}</td>
                    <td>{it.doc_no}</td>
                    <td>{it.angajat_nume}</td>
                    <td>{it.produs_cod}</td>
                    <td>{it.produs_nume}</td>
                    <td className="text-end">{it.qty}</td>
                    <td className="text-end">{format2(it.pret)}</td>
                    <td className="text-end fw-bold">{format2(it.valoare)}</td>
                  </tr>
                ))}
                {dari.length === 0 && <tr><td colSpan="8" className="text-center">Nu există date.</td></tr>}
              </tbody>
            </Table>
          )}
        </Tab>

        <Tab eventKey="transferuri" title="Transferuri">
          {loading && transferuri.length === 0 ? <Spinner animation="border" /> : (
            <Table striped bordered hover size="sm">
              <thead className="table-warning">
                <tr>
                  <th>Data</th>
                  <th>Nr. Doc</th>
                  <th>Angajat Sursă (Predă)</th>
                  <th>Angajat Destinație (Primește)</th>
                  <th>Cod Produs</th>
                  <th>Denumire</th>
                  <th className="text-end">Cantitate</th>
                  <th className="text-end">Preț</th>
                  <th className="text-end">Valoare</th>
                </tr>
              </thead>
              <tbody>
                {transferuri.map((it, idx) => (
                  <tr key={idx}>
                    <td>{it.doc_date}</td>
                    <td>{it.doc_no}</td>
                    <td>{it.sursa_nume}</td>
                    <td>{it.dest_nume}</td>
                    <td>{it.produs_cod}</td>
                    <td>{it.produs_nume}</td>
                    <td className="text-end">{it.qty}</td>
                    <td className="text-end">{format2(it.pret)}</td>
                    <td className="text-end fw-bold">{format2(it.valoare)}</td>
                  </tr>
                ))}
                {transferuri.length === 0 && <tr><td colSpan="9" className="text-center">Nu există date.</td></tr>}
              </tbody>
            </Table>
          )}
        </Tab>

        <Tab eventKey="casari" title="Casări">
          {loading && casari.length === 0 ? <Spinner animation="border" /> : (
            <Table striped bordered hover size="sm">
              <thead className="table-danger">
                <tr>
                  <th>Data</th>
                  <th>Nr. Doc</th>
                  <th>Angajat</th>
                  <th>Motiv</th>
                  <th>Cod Produs</th>
                  <th>Denumire</th>
                  <th className="text-end">Cantitate</th>
                  <th className="text-end">Preț</th>
                  <th className="text-end">Valoare</th>
                </tr>
              </thead>
              <tbody>
                {casari.map((it, idx) => (
                  <tr key={idx}>
                    <td>{it.doc_date}</td>
                    <td>{it.doc_no}</td>
                    <td>{it.angajat_nume}</td>
                    <td>{it.motiv}</td>
                    <td>{it.produs_cod}</td>
                    <td>{it.produs_nume}</td>
                    <td className="text-end">{it.qty}</td>
                    <td className="text-end">{format2(it.pret)}</td>
                    <td className="text-end fw-bold">{format2(it.valoare)}</td>
                  </tr>
                ))}
                {casari.length === 0 && <tr><td colSpan="9" className="text-center">Nu există date.</td></tr>}
              </tbody>
            </Table>
          )}
        </Tab>
      </Tabs>
    </Container>
  );
};

export default ObInvIstoricMiscari;
